import apiClient from './apiClient';

const searchService = {
  /**
   * Global search across customers, vehicles, and work orders
   */
  globalSearch: async (query, limit = 5) => {
    const response = await apiClient.get('/search', {
      params: { q: query, limit },
    });
    return response.data;
  },
};

export default searchService;
